<template>
	<div class="order" :class="userRole">
		<ImagePopup
			:active.sync="imagePopupActive"
			:file.sync="imagePopupFile"
		/>

    <ConfirmMarginalityAction
      :active.sync="marginalityPopupState"
      @confirm="createTask"
      @cancel="cancelMarginalityPopupState"
    />

    <OrderPriceIncorrectModal
      :active.sync="priceIncorrectPopupState"
      @confirm="createIncorrectOrderPriceTask"
      @cancel="cancelPriceIncorrectPopupState"
    />

    <ForceChangeStatusModal
      :active.sync="showForceChangeStatusModal"
      @confirm="updateModel(); updateStages();"
      @cancel="showForceChangeStatusModal = false"
	  :model="model"
	  :stages="stages"
    />

    <UploadJuniorAuthorWorkDialog
		v-if="model.milestone"
		:active.sync="authorFileUploadPopupState"
		:orderId="model.id"
		:orderStatus="model.status"
		:stage="model.milestone"
		@updateModel="updateModelAfterUploadFiles"
    />
	<AuthorReasignPopUp
		v-if="userRole === 'manager' || userRole === 'admin'"
		:active.sync="isDeletePopupOpen"
		:orderId="model.id"
		:orderStatus="model.status"
		:orderSubject="model.subject"
		:levels="authorLevels"
		:subjects="subjects"
		@cancel="isDeletePopupOpen = false"

	/>
	<vs-popup
		v-if="$store.state.chat.chatExpired"
		:title="$t('warning')"
		:active.sync="$store.state.chat.chatExpired"
	>
		<p>{{ $t("chatOpenTooLong") }}</p>
	</vs-popup>
		<div class="vx-row">
			<div class="vx-col w-full">
				<vx-card class="align-center">
					<div class="vx-row order__head">
						<div class="d-flex align-center flex-wrap vx-col order__head-col">
							<div class="vx-row order__head-col_inner">
								<div class="order__head-order vx-col">
									<b>{{ $t("order") }} №</b><span class="status">{{ model.id }}</span>
									<span v-if="model.client && model.client.is_ebay_client" class="ebay-badge">eBay</span>
									<span v-if="model.is_ppg_auto === 1" class="auto-badge">AUTO</span>
								</div>
								<div
									class="order__head-status vx-col"
									v-if="['admin', 'manager'].includes(userRole)"
								>
									<b>{{ $t('currentOrderStatus') }}</b>
									<span class="status" :class="$getStatusColor(model.status)">
  										{{
											model.status === 'failed_with_payout'
												? 'Failed with payout' + (model.failed_reason ? ' (' + model.failed_reason + ')' : '')
												: model.status === 'failed'
													? 'Failed' + (model.failed_reason ? ' (' + model.failed_reason + ')' : '')
													: $getStatus(model.status)
										}}
									</span>

								</div>
								<div
									class="order__head-status vx-col"
									v-if="['admin', 'manager'].includes(userRole) && model.paid_ppg === 1"
								>
									<span class="status">
										{{ $t('paidOrder') }}
									</span>
								</div>
								<div
									class="order__head-status vx-col"
									v-if="userRole === 'author'"
								>
									<b>{{ $t('price') }}</b>
									<span class="status status-price">{{ model.price }} €</span>
								</div>

								<div class="order-author vx-col order__head-col" @click="openChangeManagerPopup">
                                    <vs-dropdown
                                        vs-custom-content
                                        vs-trigger-click
                                        :fixed="true"
                                        :class="{ 'cursor-pointer': userRole === 'admin' || userRole === 'manager' || showAssignManagerButton }"
                                    >
                                        <vs-dropdown-menu
                                            v-if="userRole === 'admin' || userRole === 'manager'"
                                            vs-custom-dropdown
                                            :fixed="true"
                                            class="managers-dropdown"
                                        >
                                            <vs-dropdown-item
                                                v-for="(manager, index) in filteredManagers"
                                                :key="index"
                                                @click="openChangeManagerDropdown(manager.id)"
                                            >
                                                {{ manager.full_name }}
                                            </vs-dropdown-item>
                                        </vs-dropdown-menu>
                                        <div
                                            class="order-author__container"
                                            v-if="!!model.manager"
                                        >
                                            <div class="order-author__title">
                                                {{ $t('manager') }}
                                            </div>
                                            <div class="order-author__block">
                                                <div class="order-author__photo">
                                                    <img v-if="model.manager.photo" :src="model.manager.photo"/>
                                                </div>
                                                <div class="order-author__name">
                                                    {{ model.manager.username }}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-if="!model.manager && showAssignManagerButton"
                                            class="vx-col"
                                        >
                                            <vs-button
                                                color="primary"
                                            >
                                                {{ $t("assignAnOrder") }}
                                            </vs-button>
                                        </div>
                                    </vs-dropdown>
								</div>

								<div class="order-author vx-col order__head-col">
									<vs-dropdown
										vs-custom-content
										vs-trigger-click
										:fixed="true"
										:class="{ 'cursor-pointer': userRole === 'admin' }"
									>
										<vs-dropdown-menu
											v-if="userRole === 'admin'"
											vs-custom-dropdown
											:fixed="true"
											class="managers-dropdown"
										>
											<vs-dropdown-item
												v-for="(manager, index) in managers"
												:key="index"
												@click="openChangeGeneratorManagerDropdown(manager.id)"
											>
												{{ manager.full_name }}
											</vs-dropdown-item>
										</vs-dropdown-menu>
										<div
											class="order-author__container"
											v-if="!!model.generator_manager"
										>
											<div class="order-author__title">
												{{ $t('generatorManager') }}
											</div>
											<div class="order-author__block">
												<div class="order-author__photo">
													<img v-if="model.generator_manager.photo" :src="model.generator_manager.photo"/>
												</div>
												<div class="order-author__name">
													{{ model.generator_manager.username }}
												</div>
											</div>
										</div>
										<div
											v-if="!model.generator_manager && userRole !== 'manager' && userRole !== 'author'"
											class="vx-col"
										>
											<vs-button
												color="primary"
											>
												{{ $t("assignGeneratorManager") }}
											</vs-button>
										</div>
									</vs-dropdown>
									<vs-button
										v-if="userRole === 'admin' && model.generator_manager"
										icon
										color="danger"
										type="border"
										class="delete-contact-time mt-1 mb-1 p-2 border-none"
										@click="removeGeneratorManager"
									>
										✕
									</vs-button>
								</div>



								<div
									v-if="!!model.author && ['manager', 'admin'].indexOf(userRole) !== -1"
									class="order-author vx-col order__head-col"
								>
									<div class="order-author__container">
										<div class="order-author__title">
											{{ $t('author') }}
										</div>
										<div
										  :class="{ 'is-problem': model.author.is_problem }"
										  class="order-author__block"
										>
											<RouterLink
												:to="`/${pathToAuthor}/${model.author.id}`"
												class="order-author__link"
											>
												<div class="order-author__photo">
													<img v-if="model.author.photo" :src="model.author.photo"/>
												</div>
												<div class="order-author__name">
													{{ model.author.username }}
												</div>
											</RouterLink>
											<feather-icon
												v-if="isNotCompleted"
												icon="XIcon"
												class="text-danger mr-1 cursor-pointer"
												@click="isDeletePopupOpen = true"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="userRole === 'author'"
							class="buttons vx-col vx-row order__head-col order__controls order__head-col"
						>
							<div v-if="isNotCompleted && isAllowedToRefuse" class="vx-col order__control order__head-col">
								<vs-button
									color="danger"
									@click="refuseWork"
								>{{ $t("refuseWork") }}</vs-button>
							</div>

<!--							<div v-if="model.status !== 'completed'" class="vx-col order__control order__head-col">-->
<!--								<vs-button-->
<!--									@click="$store.dispatch('getMessages',{id: $route.params.id})"-->
<!--								>{{ $t('writeMessage') }}</vs-button>-->
<!--							</div>-->

							<div v-if="model.id" class="vx-col order__control order__head-col">
								<vs-button
									:class="{ isNewMessage: unreadAuthorMessage }"
									@click="$store.dispatch('openChat',{authorChatId, orderId: model.id})"
								>{{ $t('writeMessage') }}</vs-button>
							</div>

<!--							<div v-if="model.status === 'completed'" class="vx-col order__control order__head-col">-->
<!--								<vs-button>{{ $t('writeMessage') }}</vs-button>-->
<!--							</div>-->
						</div>
						<div
							v-if="userRole === 'manager' || userRole === 'admin'"
							class="buttons vx-col vx-row order__head-col order__controls"
						>

							<div v-if="model.id && userRole === 'admin'" class="vx-col order__control order__head-col">
								<vs-button
									color="warning"
									@click="showForceChangeStatusModal = true"
								>{{ $t('changeStatus') }}</vs-button>
							</div>

							<div v-if="model.id && canShowLongTermButton" class="vx-col order__control order__head-col">
								<vs-button
									color="#7d33ff"
									@click="confirmLongTerm"
								>{{ $t('workLongTerm') }}</vs-button>
							</div>
							<div v-if="model.id && canShowCorrectionsButton" class="vx-col order__control order__head-col">
								<vs-button
									color="#7d33ff"
									@click="confirmCorrections"
								>{{ $t('corrections') }}</vs-button>
							</div>
							<div v-if="model.id && canShowReturnFromCorrectionsButton" class="vx-col order__control order__head-col">
								<vs-button
									color="#7d33ff"
									@click="confirmReturnFromCorrections"
								>{{ $t('waitingApprove') }}</vs-button>
							</div>
							<div v-if="model.id && canShowAdditionalSaleButton" class="vx-col order__control order__head-col">
								<vs-button
									color="#7d33ff"
									@click="confirmAdditionalSale"
								>{{ $t('additionalSale') }}</vs-button>
							</div>
							<div v-if="model.id && canShowCompleteButton" class="vx-col order__control order__head-col">
								<vs-button
									color="#7d33ff"
									@click="confirmComplete"
								>{{ $t('finished') }}</vs-button>
							</div>

              				<div v-if="userRole === 'admin' && !isNotCompleted" class="vx-col order__control order__head-col">
								<vs-button

									color="warning"
									@click="refundPromptActive = true"
								>{{ $t('refund') }}</vs-button>
							</div>

							<div
								v-if="isDeletedOrder"
								class="vx-col order__control order__head-col"
								>
									<span
									class="cursor-pointer text-success"
									@click="showRestoreFromBasketDialog(model)"
									>
										<feather-icon badge size="1.5x" icon="Trash2Icon"></feather-icon>
									</span>
							</div>

							<div
								v-if="canShowNotAnswer"
								class="vx-col order__control order__head-col"
							>
								<vs-button
									color="danger"
									@click="callClientNotAnswerDialog"
								>{{ $t('clientNotAnswer') }}</vs-button>
							</div>

							<div v-if="canAddOrderToBasket && !isDeletedOrder && !isPaidOrder" class="vx-col order__control order__head-col">
								<vs-button

									color="danger"
									@click="addOrderToBasketPromptActive = true"
								>{{ $t('delete') }}</vs-button>
							</div>
							<div v-if="model.status !== 'completed' && model.status !== 'additional_sale'" class="vx-col order__control order__head-col">
								<vs-button
									color="success"
									@click="taskPopupActive = true"
								>{{ $t('addTask') }}</vs-button>
							</div>

							<div v-if="canShowAuthorChat" class="vx-col order__control order__head-col">
								<vs-button
									:class="{ isNewMessage: unreadAuthorMessage }"
									@click="$store.dispatch('openChat',{
										authorChatId,
										orderId: model.id,
										disabled: false
									})"
								>{{ $t('writeMessageToAuthor') }}
								</vs-button>
							</div>

							<div v-if="model.id && model.status !== 'completed'" class="vx-col order__control order__head-col">
								<vs-button
								:class="{isNewMessage: unreadClientMessage}"
									@click="$store.dispatch('openChat',{
										id: $route.params.id,
										disabled: !isNotCompleted
									})"
								>{{ $t('writeMessageToClient') }}</vs-button>
							</div>

							<div v-if="model.id && model.status === 'completed'" class="vx-col order__control order__head-col">
								<vs-button
									@click="$store.dispatch('openChat',{
										id: $route.params.id,
										disabled: !isNotCompleted
									})"
								>{{ $t('writeMessage') }}</vs-button>
							</div>

							<div
								v-if="model.id && userRole === 'manager' && canShowSuborderStatuses && !model.parent_id"
								class="vx-col order__control order__head-col"
							>
								<vs-button
									class="suborder_button"
									@click="openSuborderWindow"
								>
									{{ $t('createSuborder') }}
								</vs-button>
							</div>


						</div>
					</div>
				</vx-card>
			</div>
		</div>


		<div class="vx-row">

			<div class="vx-col w-full mt-8" v-if="model && model.sendpulse_unsubscribed">
				<vs-alert v-if="model && model.sendpulse_unsubscribed.resubscribe_requested === '0'" color="danger" class="mb-2" icon="report_problem" >
					{{ $t('sendpulse.unsubscribed', model.sendpulse_unsubscribed) }}
				</vs-alert>
				<vs-alert v-else color="warning" class="mb-2"  icon="schedule_send">
					{{ $t('sendpulse.resubscriptionRequested', model.sendpulse_unsubscribed) }}
				</vs-alert>
			</div>
			<div class="vx-col w-full mt-8" v-if="model && model.mailjet_unsubscribed">
				<vs-alert v-if="model && model.mailjet_unsubscribed.resubscribe_requested === '0'" color="danger" class="mb-2" icon="report_problem" >
					{{ $t('mailjet.unsubscribed', model.mailjet_unsubscribed) }}
				</vs-alert>
				<vs-alert v-else color="warning" class="mb-2"  icon="schedule_send">
					{{ $t('mailjet.resubscriptionRequested', model.mailjet_unsubscribed) }}
				</vs-alert>
			</div>
		</div>

		<div class="vx-row">

			<div class="vx-col lg:w-1/2 w-full mt-8" v-if="model && (readOnly || userRole === 'author')">
				<CardTicketView
					:model="model"
					:levels="levels"
					:subjects="subjects"
					:works="works"
					:languages="languages"
					:payTypes="payTypes"
					:stages="stages"
					:isEditView.sync="isEditView"
					@openImagePopup="openImagePopup"
					@updateModel="updateModel"
					style="width: 100%"
				/>

				<ClientFiles
					v-if="hasClientFiles && userRole === 'author'"
					:orderId="model.id"
					:userRole="userRole"
					:model="model"
					:sending.sync="model.auto_send_status"
					:orderStatus="model.status"
					@updateModel="updateModelAfterDeleteFiles"
					@openImagePopup="openImagePopup"
				/>

				<template v-if="['admin', 'manager'].indexOf(userRole) !== -1">
					<ClientFiles
						v-if="hasClientFiles"
						:orderId="model.id"
						:userRole="userRole"
						:model="model"
						:sending.sync="model.auto_send_status"
						:orderStatus="model.status"
						@updateModel="updateModelAfterDeleteClientFiles"
						@openImagePopup="openImagePopup"
					/>

					<AuthorSearch
						v-if="model.status === 'waiting_author'"
						ref="authorSearch"
						:orderId="model.id"
						:levels="authorLevels"
						:subjects="subjects"
						:orderSubject="model.subject"
            			:marginalityState="authorsSearchMarginalityState"
						@updateModel="updateModel"
						@updateStages="updateStages"
						@updateAuthor="updateAuthor"
					/>

					<StagesFiles
						v-if="canShowStagesFiles"
						:orderId="model.id"
						:stages="stages"
						:is-ppg-auto="model.is_ppg_auto"
						:sending.sync="model.auto_send_status"
            			:orderStatus="model.status"
						@updateModel="updateModelAfterDeleteFiles"
						@openImagePopup="openImagePopup"
					/>

					<vs-button
						v-if="model.author && model.author.quality_level_id === 4"
						color="primary"
						class="mt-4"
						@click="openUploadPrompt"
					>
						{{ $t('loadFile') }}
					</vs-button>

				</template>

			</div>
			<div class="vx-col lg:w-1/2 w-full mt-8" v-else>
				<CardTicketEdit
					ref="CardTicketEdit"
					:model="model"
					:subjects="subjects"
					:languages="languages"
					:levels="levels"
					:payTypes="payTypes"
					:works="works"
					:isEditView.sync="isEditView"
					:isMarginalityLow="isMarginalityLow"
					:inputHasChanged="inputHasChanged"
					@updateTicket="updateTicket"
					@recalcPrices="recalcPrices"
					@updatedWorkType="updateStagesTypes"
					@openImagePopup="openImagePopup"
					@updateModel="updateModel"
				/>
				<ClientFiles
					v-if="hasClientFiles"
					:orderId="model.id"
					:userRole="userRole"
					:model="model"
					:sending.sync="model.auto_send_status"
					:orderStatus="model.status"
					@updateModel="updateModelAfterDeleteClientFiles"
					@openImagePopup="openImagePopup"
				/>
			</div>
			<!-- Author -->
			<div
				class="vx-col lg:w-1/2 w-full mt-8"
				v-if="
					userRole === 'author' && isNotCompleted && model.id
				"
			>
				<AuthorUpload
					:orderId="model.id"
					:orderStatus="model.status"
					:stage="model.milestone"
					:can-upload-files="model.can_upload_files"
					@updateModel="updateModel"
				/>
			</div>
			<!-- End Author -->
			<div
				class="vx-col lg:w-1/2 w-full mt-8"
			>
				<CardStages
					v-if="userRole !== 'author'"
					ref="CardStages"
					:orderId="model.id"
					:stages="stages"
					:status="model.status"
					:works="selectedWorks"
					:author="author"
					:isEditMode="isEditView"
					:enableWorkTypesList="enableWorkTypesList"
					:currentSubject="currentSubject"
					:amountOfIncome="amountOfIncome"
					:isMarginalityLow="isMarginalityLow"
					:inputHasChanged.sync="inputHasChanged"
					:isPriceIncorrect="isPriceIncorrect"
					:promocode="model.promocode"
					@updateModel="updateModel"
					@updateStages="updateStages"
					@confirmOrder="confirmOrder"
					@updateAuthor="updateAuthor"
					@openImagePopup="openImagePopup"
				/>
			</div>
		</div>
		<AddOrderTask
			:active.sync="taskPopupActive"
			:order="model"
		/>
		<RefuseWorkPrompt
			v-if="model.id"
			:active.sync="refusePromptActive"
			:orderNumber="model.id"
			@accept="sendRefuse"
		/>
		<AddOrderToBasketPrompt
			v-if="model.id"
			:active.sync="addOrderToBasketPromptActive"
			@accept="sendReasonAndAddOrderToBasket"
		/>
		<RefundPopup
			v-if="model.id"
			:active.sync="refundPromptActive"
			@confirm="sendRefundReason"
		/>
        <vs-prompt
            :active="confirmPrompt"
            :buttons-hidden="true"
            :title="$t('confirmAction')"
            button-accept="false"
            button-cancel="filled"
            :cancel-text="$t('refuse')"
            color="warning"
			@close="resetChange"
		>
            <div class="d-flex justify-end">
                <vs-button
                    @click="confirmChange"
                    color="warning"
                >{{ $t('confirm') }}</vs-button>
            </div>
        </vs-prompt>
	</div>
</template>

<script>
import ImagePopup from "@/components/dialogs/ImagePopup";
import CardTicketEdit from "@/views/Tickets/CardTicketEdit";
import CardTicketView from "@/views/Tickets/CardTicketView";
import AuthorSearch from "@/views/Tickets/AuthorSearch";
import AuthorUpload from "@/views/Tickets/AuthorUpload";
import StagesFiles from "@/views/Tickets/StagesFiles";
import CardStages from "@/views/Tickets/CardStages";
import AddOrderTask from "@/components/dialogs/AddOrderTask";
import RefuseWorkPrompt from "@/components/dialogs/RefuseWorkPrompt";
import datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import orderStatusesList from "@/assets/configs/orderStatusesList";
import AddOrderToBasketPrompt from "@/components/dialogs/AddOrderToBasketPrompt";
import RefundPopup from '@/components/dialogs/RefundPopup.vue';
import ConfirmMarginalityAction from "@/components/dialogs/ConfirmMarginalityAction.vue";
import OrderPriceIncorrectModal from "@/components/dialogs/OrderPriceIncorrectModal.vue";
import ForceChangeStatusModal from "@/components/dialogs/ForceChangeStatus.vue";
import UploadJuniorAuthorWorkDialog from '@/components/dialogs/UploadJuniorAuthorWorkDialog.vue'
import moment from "moment";
import AuthorReasignPopUp from "@/components/managers/AuthorReasignPopUp.vue";
import ClientFiles from "@/views/Tickets/ClientFiles.vue";

let updatingInterval = null;

export default {
	name: "Ticket",
	mixins: [databaseManager, notifier],
	data() {
		return {
			selected: [],
			setFailedReason: 1,
			currentStage: 0,
			isPaidOrder: true,
			works: [],
			subjects: [],
			languages: [],
			levels: [],
			authorLevels: [],
			sites: [],
			payTypes: [],
			model: { },
			refusePromptActive: false,
			taskPopupActive: false,
			addOrderToBasketPromptActive: false,
      		refundPromptActive: false,
			taskAbout: '',
			taskDate: '',

			stages: [],

			updateTimeout: null,

			author: null,

			unreadAuthorMessage: false,
			unreadClientMessage: false,

			imagePopupActive: false,
			imagePopupFile: null,

			isEditMode: false,
			managers: [],
			managerIdToSetToOrder: null,
			confirmPrompt: false,
			showForceChangeStatusModal: false,

			enableWorkTypesList: [],

			isMarginalityLow: false,
			marginalityPopupState: false,
			isMarginalityTaskCreated: false,
			inputHasChanged: false,

			priceIncorrectPopupState: false,
			isPriceIncorrectTaskCreated: false,

			authorFileUploadPopupState: false,

			isDeletePopupOpen: false,

			typeOfChange: null,
			generator_manager_id: null
		};
	},
	components: {
		ClientFiles,
		AuthorReasignPopUp,
		UploadJuniorAuthorWorkDialog,
		AddOrderToBasketPrompt,
		CardTicketEdit,
		CardTicketView,
		AuthorSearch,
		AuthorUpload,
		StagesFiles,
		CardStages,
		AddOrderTask,
		RefuseWorkPrompt,
		datepicker,
		vSelect,
		ImagePopup,
    	RefundPopup,
		ConfirmMarginalityAction,
		OrderPriceIncorrectModal,
		ForceChangeStatusModal,
	},

	watch: {
		chatStatus() {
			if(this.isMessageSent) {
				setTimeout(() => this.updateModel(), 300);
			}
		},

		updatedTicketId(newValue) {
			if (newValue) {
				this.updateModel()
			}
		},

		isPriceIncorrect(newVal) {
			if (newVal) {
				this.isPriceIncorrectTaskCreated = false;
			}
		},

    inputHasChanged(val) {
      if (val) {
				this.isPriceIncorrectTaskCreated = false;
				this.isMarginalityTaskCreated = false;
      }
    }
	},

	computed:{
    lowMargStage() {
      if (this.stages && this.stages.length) {
        const lowMargStage = this.stages.find(
          el => el.marginality_correct === false && (el.status !== "completed" &&
            el.status !== "failed_with_payout" &&
            el.status !== "failed")
        )

        return !!lowMargStage
      }
      return false
    },

    isPriceIncorrect() {
      if (this.model) {
        if (!this.model.price_correct) {
          return true
        }

        return false
      }
      return false
    },

    authorsSearchMarginalityState() {
      if (this.stages && this.stages.length) {
        const obj = this.stages.find((el) => el.marginality_correct === false)

        return !!obj
      }

      return false
    },

    isEditView: {
      get() {
        return this.isEditMode
      },
      async set(val) {
        if (!val) {
          await this.checkMarginality()

          if (!this.inputHasChanged) {
            this.isEditMode = val
            await this.setOrderViewState()
            return
          }

          if (
            this.isPriceIncorrect &&
            !this.isPriceIncorrectTaskCreated &&
            this.lowMargStage && !this.isMarginalityTaskCreated
          ) {
            this.priceIncorrectPopupState = true;
            this.marginalityPopupState = true;
          } else if (
            this.isPriceIncorrect &&
            !this.isPriceIncorrectTaskCreated
          ) {
            this.priceIncorrectPopupState = true;
          } else if (this.lowMargStage && !this.isMarginalityTaskCreated) {
            this.marginalityPopupState = true;
          } else {
            this.isEditMode = val
            await this.setOrderViewState()
          }
        } else {
          this.isEditMode = val
          await this.setOrderUpdateState()
        }

      },
    },

    amountOfIncome() {
      return !!this.model ? this.model.payments : 0
    },
    currentSubject() {
      if (this.model && this.subjects) {
        const currentSubject = this.subjects.find(el => el.id === this.model.subject)
        return currentSubject
      }
      return null
    },
    filteredManagers() {
        if (this.managers.length) {
            this.managers.map((el) => {
                el.full_name = `${el.first_name} ${el.last_name}`
            })
            return this.managers
        }
        return []
    },
    showAssignManagerButton() {
        if (this.userRole === 'manager' && !!this.model && this.model.status === 'new') return true;
        if (this.userRole === 'admin') return true;
        return false;
    },
		isDeletedOrder(){
			return this.model.status === 'deleted'
		},
		isNotCompleted() {
			return this.model.id
				&& this.model.status !== 'completed'
				&& this.model.status !== 'failed_with_payout'
				&& this.model.status !== 'failed';
		},
		canShowSuborderStatuses() {
			const allowedStatuses = ['waiting_payment', 'waiting_author', 'in_progress', 'waiting_approve', 'additional_sale'];
			return this.model && allowedStatuses.includes(this.model.status);
		},
		isAllowedToRefuse() {
			return false;
		},
		userRole() {
			return this.$store.state.auth.role;
		},
		readOnly() {
			if(!this.model || !this.model.status) return true;


			if(this.model.status === 'new'
				|| this.model.status === 'new_ppg'
				|| this.model.status === 'client_not_answer'
				|| this.model.status === 'offer_sent'
				|| this.model.status === 'work_long_term'
				|| this.model.status === 'processing') return false

            if (this.isEditView) return false

			return true;
		},
		authorChatId() {
			return this.model.author_chat_id;
		},
		canShowAuthorChat() {
			return this.authorChatId !== null
				&& this.authorChatId !== undefined
		},
		selectedWorks() {
      const arr = []
      for (const work of this.works) {
        if(!this.model.work_types) return

        for (const work_type of this.model.work_types) {
          if (work.id === work_type.work_type_id) {
            arr.push({
              ...work,
              recommendedPrice: work_type.recommended_price,
              pages: work_type.pages_number
            })
          }
        }
      }
      return arr
		},
		pathToAuthor() {
			const role = this.userRole;
			if(role === "admin") {
				return "author";
			} else if(role === "manager") {
				return "authorM";
			}

			return "";
		},
		canShowStagesFiles() {
			const role = this.userRole === "admin" || this.userRole === "manager";
			if (!role || !this.model || !this.stages.length) {
				return false;
			}

			return this.stages.some(stage => {
				const files = stage.files || [];
				if (!files.length) {
					return false;
				}

				if (this.model.is_ppg_auto === 1) {
					return files.some(file => !file.s3_id);
				}

				return true;
			});
		},
		canShowNotAnswer() {
			return this.model.status !== orderStatusesList.STATUS_NEW
				&& this.model.status !== orderStatusesList.STATUS_NEW_PPG
				&& this.model.status !== orderStatusesList.STATUS_COMPLETED
				&& this.model.status !== orderStatusesList.STATUS_ADDITIONAL_SALE
				&& this.model.status !== orderStatusesList.STATUS_FAILED_WITH_PAYOUT
				&& this.model.status !== orderStatusesList.STATUS_FAILED
				&& this.model.status !== orderStatusesList.STATUS_CLIENT_NOT_ANSWER
				&& this.model.status !== orderStatusesList.STATUS_WAITING_AUTHOR;

		},
		hasClientFiles() {
			return this.model.files && Array.isArray(this.model.files) && this.model.files.length > 0;
		},
		chatStatus() {
			return this.$store.state.chat.status;
		},
		isMessageSent() {
			return this.getMessageSentStatus();
		},
		canAddOrderToBasket()
		{
			return this.model.status === orderStatusesList.STATUS_NEW
				|| this.model.status === orderStatusesList.STATUS_NEW_PPG
				|| this.model.status === orderStatusesList.STATUS_DELETED
				|| this.model.status === orderStatusesList.STATUS_CLIENT_NOT_ANSWER
				|| this.model.status === orderStatusesList.STATUS_PROCESSING
				|| this.model.status === orderStatusesList.STATUS_OFFER_SENT
				|| this.model.status === orderStatusesList.STATUS_WAITING_PAYMENT
				|| this.model.status === orderStatusesList.STATUS_WORK_LONGTERM

		},
		updatedTicketId() {
			if (this.$route.params.id)
			return this.$route.params.id
		},
		canShowLongTermButton() {
			return ['processing', 'offer_sent'].includes(this.model.status);
		},
		canShowCorrectionsButton() {
			return ['waiting_approve', 'completed'].includes(this.model.status);
		},
		canShowReturnFromCorrectionsButton() {
			return this.model.status === 'corrections';
		},
		canShowAdditionalSaleButton() {
			return ['completed'].includes(this.model.status);
		},
		canShowCompleteButton() {
			return ['additional_sale'].includes(this.model.status);
		},

	},

	async mounted() {
		if (updatingInterval !== null) clearInterval(updatingInterval)
		this.checkMessagesStatus()
		updatingInterval = setInterval( () => {
			this.checkMessagesStatus()
		}, 30000);

		this.$root.$on('fileAddedToOrder', this.updateClientFilesFromChat);

		window.addEventListener('storage', this.onSuborderCreated);
	},
	beforeUnmount() {
		window.removeEventListener('storage', this.onSuborderCreated);
	},
	beforeDestroy() {
		this.$root.$off('fileAddedToOrder', this.updateClientFilesFromChat);
	},
	methods: {
		openUploadPrompt() {
			this.authorFileUploadPopupState = true
		},
    async checkIfOrderHasNewStages() {
      // if (this.model.state === 'view') {
      //   return
      // }
	  //
	  //
	  //
      // const newStage = this.stages.find((el) => el.is_new)
	  //
      // if (!newStage) {
      //   return
      // }
	  //
      // for (const stage of this.stages) {
      //   if (stage.is_new) {
      //     await this.deleteNewStageInEditMode(stage.id)
      //   }
      // }

		return
    },

    async setOrderUpdateState() {
      try {
        await this.dbSetOrderUpdateState(this.model.id)
      } catch (err) {
        console.error(err);
      }
    },
    async setOrderViewState() {
      try {
        await this.dbSetOrderViewState(this.model.id)
      } catch (err) {
        console.error(err);
      }
    },

    async cancelMarginalityPopupState() {
      this.marginalityPopupState = false
    },

    async cancelPriceIncorrectPopupState() {
      this.priceIncorrectPopupState = false
    },

    async deleteNewStageInEditMode(stageId) {
      try {
        await this.dbRemoveStage(stageId);
        await this.updateStages()
      } catch (err) {
        console.error(err);
      }
    },

    async createTask() {
      try {
        if (!this.isMarginalityTaskCreated) {
          await this.dbCreateMarginalityTask(this.model.id)

          this.isMarginalityTaskCreated = true
        }

        if (this.priceIncorrectPopupState) {
          return
        }

				if (this.isPriceIncorrect && !this.isPriceIncorrectTaskCreated) {
					return;
				}

        this.inputHasChanged = false
        this.isEditView = false
      } catch (e) {
        console.error(e);
      }
    },

    async createIncorrectOrderPriceTask() {
      try {
        if (!this.isPriceIncorrectTaskCreated) {
          await this.dbCreateOrderPriceTask(this.model.id)

          this.isPriceIncorrectTaskCreated = true
        }

        if (this.marginalityPopupState) {
          return
        }

        if (this.lowMargStage && !this.isMarginalityTaskCreated) {
          return;
        }

        this.inputHasChanged = false
        this.isEditView = false
      } catch (e) {
        console.error(e);
      }
    },

    async checkMarginality() {
			await this.saveNewStagesInEditMode()
      await this.updateStages()

      if (!this.stages || !this.stages.length) {
        return
      }

      this.isMarginalityLow = !!this.lowMargStage
    },

		async saveNewStagesInEditMode() {
			for (const stage of this.stages) {
        if (stage.id || !stage.pages_number) {
          continue
        }

				stage.due_date = moment(stage.due_date).format(
					"YYYY-MM-DD"
				);

        try {
          const newStage = await this.dbCreateStage(this.model.id, stage)
          this.$set(stage, 'id', newStage.id)
        } catch (e) {
          this.notifyError(e.message);
        }
      }

		},

    setLowMarginality(data) {
      this.isMarginalityLow = data
    },

    async sendRefundReason(reason, amount) {
      const orderId = this.model.id;
      try {
        const res = await this.dbSendRefund(orderId, reason, amount)
        if (!res) return
        this.notifySuccess()
      } catch (e) {
        this.notifyError(e.message);
      }
    },

	openChangeManagerDropdown(id) {
		this.managerIdToSetToOrder = id;
		this.typeOfChange = "manager";
		this.confirmPrompt = true;
	},

	openChangeGeneratorManagerDropdown(id) {
		console.log('CLICKED MANAGER ID:', id);
		this.generator_manager_id = id;
		this.typeOfChange = 'generator';
		this.confirmPrompt = true;
	},



		openChangeManagerPopup(id) {
	//if (this.userRole === 'manager') this.confirmPrompt = true;
    },

    async changeManager() {
        const orderId = this.model.id;
        try {
            if (this.userRole === 'manager') {
                await this.dbSetCurrentManagerToOrder(orderId, this.managerIdToSetToOrder)
            } else if (this.userRole === 'admin') {
                await this.dbSetManagerToOrder(orderId, this.managerIdToSetToOrder)
            }
            this.confirmPrompt = false;
            this.updateModel()
            this.notifySuccess()
        } catch (e) {
            this.notifyError(e.message);
        }
    },
		async changeGeneratorManager() {

			const orderId = this.model.id;

			try {
				if (this.userRole === 'admin') {
					await this.dbSetGeneratorManagerToOrder(orderId, this.generator_manager_id)
				}
				this.confirmPrompt = false;
				this.updateModel();
				this.notifySuccess();
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async removeGeneratorManager() {
			try {
				const orderId = this.model.id;

				await this.dbSetGeneratorManagerToOrder(orderId, null);

				this.model.generator_manager = null;
				this.model.generator_manager_id = null;

				this.notifySuccess();
			} catch (e) {
				this.notifyError(e.message);
			}
		},

		async confirmChange() {
			if (this.typeOfChange === 'manager') {
				await this.changeManager();
			}

			if (this.typeOfChange === 'generator') {
				await this.changeGeneratorManager();
			}
		},
		resetChange() {
			this.confirmPrompt = false;
			this.typeOfChange = null;
			this.managerIdToSetToOrder = null;
			this.generator_manager_id = null;
		},

		openImagePopup(e, file) {
			if (!file || !file.url) return

			if (file.url.toLowerCase().includes('jpeg') ||
				file.url.toLowerCase().includes('jpg') ||
				file.url.toLowerCase().includes('png')
			) {
				e.preventDefault()
				this.imagePopupActive = true
				this.imagePopupFile = file
			}
		},
		showRestoreFromBasketDialog(order) {
			this.$vs.dialog({
				color: "success",
				title: this.$t(`confirmUnblockingOrder`),
				acceptText: this.$t(`confirm`),
				cancelText: this.$t(`doCancel`),
				text: this.$t('confirmUnblockingOrder') + " №" + order.id,
				accept: async () => {
					try {
						const response = (await this.$http.post(
							`/${this.$store.state.auth.role}/order/activate/${order.id}`
						)).data;
						if (response.status === 200 && response.data.set_active_status) {
							this.notifySuccess(this.$t('orderRestoredSuccessfully'));
							this.$router.go(this.$router.currentRoute)
						} else {
							throw new Error('Something went wrong')
						}
					} catch (e) {
						this.notifyError(e.message);
					}
				},
			});
		},
		async sendReasonAndAddOrderToBasket(order_delete_reason_id) {
			try {
				const response = (await this.$http.post(`/${this.userRole}/order/delete/${this.model.id}`, {
					order_delete_reason_id,
					id: this.model.id
				})).data;
				if (response.status === 200 && response.data.set_deleted_status) {
					this.notifySuccess(this.$t('orderAddedToBasket'));
					this.$router.go(this.$router.currentRoute)
				} else {
					throw new Error('Something went wrong')
				}
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async checkMessagesStatus() {
			if (this.userRole === "client") return false
			if (this.$route.params.id !== null && this.$route.params.id !== undefined) {
				const unreadMessage = await this.dbCheckMessagesStatus(this.$route.params.id)

				this.unreadAuthorMessage = unreadMessage.unread_author_chat
				this.unreadClientMessage = unreadMessage.unread_client_chat

			}
		},
		async confirmOrder(callback) {
			try {
				const validation = await this.$refs.CardTicketEdit.validateOrder();
				if(validation !== true) {
					callback();
					return;
				}

				await this.dbConfirmOrder(this.model.id);
				this.notifySuccess(this.$t('dataWasSentForApproval'));
				await this.updateModel();
				await this.updateStages();

			} catch (e) {
				this.notifyError(e.message);
			}

			callback();
		},
		getMessageSentStatus() {
			if(this.model.status !== "new" && this.model.status !== "client_not_answer")
				return false;

			return this.$store.state.chat.payload
				&& this.$store.state.chat.payload.id
				&& this.$store.state.chat.status === "loading";
		},
		async updateModel(callback) {
			this.model = await this.viewOrder();
      		this.author = this.model.author;
			await this.loadWorks();

			this.$nextTick(() => {
				if(callback) callback();
			});
		},
		async updateModelAfterUploadFiles() {
			this.model = await this.viewOrder();
			await this.updateStages()
		},
		async updateModelAfterDeleteFiles() {
			this.model = await this.viewOrder();
			await this.updateStages()
		},
		async updateModelAfterDeleteClientFiles() {
			this.model = await this.viewOrder();
			await this.updateClientFiles()
		},
		async updateStages() {
			try {
				this.stages = await this.dbViewStages(this.$route.params.id);
			} catch (e) {
				console.error(e);
			}
		},
		async updateClientFiles() {
			try {
				this.files = this.model.files;
			} catch (e) {
				console.error(e);
			}
		},
		async updateClientFilesFromChat() {
			try {
				this.model = await this.viewOrder();
				this.files = this.model.files;
			} catch (e) {
				console.error(e);
			}
		},
		async updateAuthor() {
			const role = this.userRole;
			this.author = this.model.author
				? (await this.$http.get(`/${role}/author/view/${this.model.author.id}`)).data.data
				: null
		},
		async sendRequests(){
			this.selected.forEach(async item => await this.sendRequest(item.id));
			this.notifySuccess(this.$t('invitesWasSent'));
		},
		async sendRequest(id){
			try {
				await this.$http.post('/manager/order/invite-author/'+this.$route.params.id,{author_id: id})
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async sendRefuse() {
			try {
				let res = await this.$http.post(
					"/author/order/cancel/" + this.$route.params.id
				);

				this.$router.back();
			} catch (e) {}
		},
		refuseWork() {
			this.refusePromptActive = true;
		},
		async makeAuthorDeletion() {
			try {
				await this.dbDeleteAuthorFromOrder(this.model.id);
				this.notifySuccess(this.$t("youDeletedAuthorFromOrder"));

				await this.updateModel();
				await this.updateStages();

			} catch (e) {
				this.notifyError(this.$t('errorNotification'));
			}
		},
		deleteAuthor() {
			this.$vs.dialog({
				type:'confirm',
				color: 'danger',
				title: this.$t('confirmDeletion'),
				text: this.$t('doYouWantToDeleteAuthorFromOrder'),
				accept: this.makeAuthorDeletion,
				acceptText: this.$t('confirm'),
				cancelText: this.$t('cancel')
			});
		},
		async setClientNotAnswer() {
			try{
				await this.dbSetClientNotAnswer(this.model.id);
				this.notifySuccess(`${this.$t('youMarkedOrderAs')} "${this.$t('clientNotAnswer')}"`);
				await this.updateModel();

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		callClientNotAnswerDialog() {
			this.$vs.dialog({
				color: "warning",
				title: this.$t('confirmAction'),
				acceptText: this.$t('agree'),
				text: `${this.$t('youWantToMarkOrderAs')} "${this.$t('clientNotAnswer')}"`,
				accept: this.setClientNotAnswer,
			});
		},
		openSuborderWindow() {
			const url = this.$router.resolve({
				path: '/ticket/create',
				query: { parent_id: this.model.id }
			}).href;

			window.open(url, '_blank');
		},
		onSuborderCreated(event) {
			if (event.key === 'new_suborder' && event.newValue) {
				try {
					const suborder = JSON.parse(event.newValue);

					this.model.suborders.push({
						id: suborder.id,
						link: `/ticket/${suborder.id}`,
						created: suborder.created,
						created_by: suborder.created_by || '—',
					});

					localStorage.removeItem('new_suborder');
				} catch (e) {
					console.error('Failed to parse suborder event', e);
				}
			}
		},
		async viewOrder() {
			const id = this.updatedTicketId;
			return await this.dbViewOrder(id);
		},
		updateTicket(newTicket) {
			this.model = newTicket;
			this.$refs.CardStages.updateRecommendedPrice()
		},
    recalcPrices(needsRecalc) {
      if (needsRecalc) {
        this.$refs.CardStages.updateAllPrices()
      }
    },
		async updateStagesTypes(type) {
			await this.$refs.CardStages.updateStagesTypes(type);
		},
		async callAllAsyncMethods(array) {
			await Promise.all(array.map((item) =>
				new Promise(async resolve => { await item(); resolve(); })
			));
		},
		async loadEnableWorkTypesList() {
		  try {
					const res = await this.dbViewWebsite(this.model.website_id);
			this.enableWorkTypesList = res.enable_work_types
				} catch(e) {
					this.notifyError(e.message);
				}
		},
		async loadWorks() {
			if (!this.model || !this.model.website_id) {
				this.works = (await this.$http.get("/settings/get-work-types")).data.data;
				return;
			}

			const include = (this.model.work_types || []).map(item => item.work_type_id);
			const params = {
				website_id: this.model.website_id,
			};

			if (include.length) {
				params.include = include;
			}

			this.works = (await this.$http.get("/settings/get-work-types", { params })).data.data;
		},
		async confirmLongTerm() {
			///send api request
			await this.setStatus('work_long_term');
			await this.updateModel();
			this.$emit("confirm");
			this.activeProp = false;
		},
		async confirmCorrections() {
			await this.setStatus('corrections');
			await this.updateModel();
			await this.updateStages();
			this.$emit("confirm");
			this.activeProp = false;
		},
		async confirmReturnFromCorrections() {
			await this.setStatus('waiting_approve');
			await this.updateModel();
			await this.updateStages();
			this.$emit("confirm");
			this.activeProp = false;
		},
		async confirmAdditionalSale() {
			///send api request
			await this.setStatus('additional_sale');
			await this.updateModel();
			this.$emit("confirm");
			this.activeProp = false;
		},
		async confirmComplete() {
			///send api request
			await this.setStatus('completed');
			await this.updateModel();
			this.$emit("confirm");
			this.activeProp = false;
		},
		async setStatus(status) {
			const id = this.updatedTicketId;
			const {
				active_milestone_id,
				active_milestone_status
			} = this;
			return await this.dbSetTicketStatus(this.model.id, {
				status,
				active_milestone_id,
				active_milestone_status
			});
		}
	},
	async created() {
		const role = this.userRole;

		const asyncOrderMethods = [
      async () => this.stages = await this.dbViewStages(this.$route.params.id),
			async () => this.levels = (await this.$http.get("/settings/get-quality-levels")).data.data,
			async () => this.languages = (await this.$http.get("/settings/get-languages")).data.data,
			async () => this.subjects = (await this.$http.get("/settings/get-subjects")).data.data,
			async () => {
        try {
          this.model = await this.viewOrder();
          await this.loadWorks();
        } catch (err) {
          console.error(err);
        }
      },
			// async () => await this.$http.get("/chat"),
      async () => {
        if (role !== 'author') {
          this.managers = (await this.dbGetMangers())
        }
      },
		]

    try {
      await this.callAllAsyncMethods(asyncOrderMethods)
    } catch (err) {
      console.error(err);
    }

		if(role === 'author') return;

		const asyncAuthorMethods = [
			async () => this.isPaidOrder = (await this.dbGetOrderStatusPaid(this.$route.params.id)).paid,
			async () => this.payTypes = (await this.$http.get("settings/get-pay-types")).data.data,
			async () => this.authorLevels = (await this.$http.get(`/${role}/author/get-quality-level-list`)).data.data,
			async () => await this.updateAuthor(),
		]

		await this.callAllAsyncMethods(asyncAuthorMethods)
    await this.loadEnableWorkTypesList()

    await this.checkIfOrderHasNewStages()
	},
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/functions";
@import "./src/assets/scss/vuexy/variables";

.managers-dropdown {
    max-width: 200px;
    width: 100%;
}

.isNewMessage {
	box-shadow: 0px 0px 10px 4px #ff9f42;
}

.align-center {
	align-items: center;
}
.mini-img{
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	border-radius: 100%;
}
tr.active{
	background-color: #CAF7AD;
}

.items-start {
	margin-top: 20px;
}

//.con-input-upload {
//	margin: 0;
//}

.con-img-upload {
	padding: 0;
	margin-top: 0;
}

.flex-wrap {
	flex-wrap: wrap;
}

.vs-table--search{
	max-width: 100%;
	width: 100%;
	border-radius: 2px !important;
}
.vs-table--search-input{
	max-width: 100%;
	width: 100%;
}
.justify-between {
	justify-content: space-between;
}

.d-flex {
	display: flex;
}
.suborder_button {
	background-color: #9c9c9c !important;
}
.order {
	.order-author__remove {
		color: #e74c3c;
		font-size: 14px;
		margin-left: 8px;
		cursor: pointer;
		transition: 0.2s;
		display: flex;
		margin-left: 8px;
		justify-content: center;
		align-items: center;
	}

	.order-author__remove:hover {
		color: #c0392b;
	}

	.vx-input-group .append-text.btn-addon .vs-button {
		height: 2.6rem;
		width: 2.6rem;
		justify-content: center;
		padding: 0 !important;
		margin-top: 21px;
		align-items: center;
		border-color: #e4e4e4 !important;
		border-left: 0 !important;
		background-color: #f7f6f6 !important;
	}

	&__head {
		@media screen and (max-width: 580px){
			justify-content: center !important;
		}
	}

	&__head-col {
		@media screen and (max-width: 768px) {
			justify-content: stretch;

			&_inner {
				justify-content: center;
				margin-top: -10px;

				& > .vx-col {
					margin-top: 10px;
				}
			}
		}
	}

	&__controls {
		.order__control {
			.vs-button {
				width: 100%;
				padding: 8px 15px !important
			}
		}

		@media screen and (max-width: 576px) {
			flex-direction: column;
			flex: 1 0 auto;
			max-width: 470px;
		}
	}

	&-author {
		display: flex;

		&__container {
			display: flex;
		}

		&__title {
			display: flex;
			align-items: center;
			font-size: 18px;
			font-weight: 600;
		}

		&__block {
			position: relative;
			display: flex;
			align-items: center;
			border-radius: 1000px;
			background-color: #F8F8F8;
			height: 35px;
			border: rgba(136, 136, 136, 0.5) 1px solid;
			//padding: 0 12px 0 0 !important;
			margin-left: 10px;

        &.is-problem {
          // box-shadow: 1px 1px 5px 0 rgba(var(--vs-danger),1);
          // border: 1px solid rgba(var(--vs-danger),1);
          background: rgba(var(--vs-danger),1);

          .feather-icon {
            color: #2d2d2d !important;
          }
        }
		}

		&__link {
			display: flex;
			align-items: center;
			height: 100%;
			border-radius: 1000px;
		}

		&__photo {
			position: absolute;
			left: -1px;
			border-radius: 100%;
			width: 35px;
			height: 35px;
			overflow: hidden;
		    background-color: $primary;

			img {
				width: 100%;
				height: 100%;
				border-radius: 100%;
			}
		}

		&__name {
			margin-left: 45px;
      margin-right: 13px;
			color: #3D3D3D;
			font-weight: 600;
			white-space: nowrap;
		}
	}

	.vs-con-input-label {
		width: 220px;
	}

	.status {
		font-size: rem(14px);
		background-color: $primary;
		color: white;
		padding: 5px 10px;
		border-radius: 10px;
		flex-shrink: 0;

		&-ok {
			background-color: $success;
		}

		&-warn {
			background-color: $warning;
		}

		&-dang {
			background-color: $danger;
		}
	}

	&__details {
		td {
			padding-bottom: 5px;

			&:first-child {
				width: 300px;
			}
		}
	}

	.vx-card__body {
		padding: 1rem 1.5rem !important;
	}

	&__head {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: -8px;
		margin-bottom: -8px;

		@media (max-width: 768px) {
			margin-top: -4px;
			margin-bottom: -4px;

			&-col {
				margin-top: 0px;
				margin-bottom: 4px;
			}
		}

		b {
			margin-right: 10px;
		}

		&-status,
		&-order {
			align-items: center;
			display: flex;
		}

		&-info {
			display: flex;
			align-items: center;
		}

		&-col {
			margin-top: 8px;
			margin-bottom: 8px;
		}
	}

	.manager {
		display: flex;
		align-items: center;
		background-color: #f8f8f8;
		border-radius: 20px;

		strong {
			padding: 0 10px;
		}
	}
}
.fileName{
	background-color: #cfcfcf;
	border-radius: 20px;
	display: inline-flex;
	color: #212121de !important;
	align-items: center;
	padding-right: 15px;
	margin-right: 15px;
	span{
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #0d47a1;
		height: 32px;
		width: 32px;
		flex-shrink: 0;
		border-radius: 100%;
		margin-right: 10px;

	}
}

.editTicket {
	.vs-con-input-label {
		width: 100%;
	}
}
blockquote {
	border-left: 4px solid #ccc;
	padding-left: 16px;
}

.ebay-badge {
	margin-left: 8px;
	padding: 2px 8px;
	font-size: 16px;
	font-weight: 600;
	border-radius: 4px;
	background: #e8f4fd;
	color: #0064d2;
}

.auto-badge {
	margin-left: 8px;
	padding: 2px 8px;
	font-size: 16px;
	font-weight: 600;
	border-radius: 4px;
	background: #fff3e0;
	color: #e65100;
}
</style>
